import { convertNotionalToBRL } from './convertNotionalToBRL.js'

// Sum of BRL notional across ALL rows regardless of status (DEAL,
// NOTH.DONE, REJECTED, ...). effectiveSpotByRow must come from
// createEffectiveSpotMap(allRows) - see convertNotionalToBRL.js.
export function calculateTotalVolumeBRL(rows, effectiveSpotByRow) {
  return rows.reduce((total, row) => {
    const amount = convertNotionalToBRL(row, effectiveSpotByRow.get(row))

    if (amount == null) return total

    return total + amount
  }, 0)
}
